<template>
    <article class="anchor-card h-full">
        <NuxtLink
            :to="
                localePath({
                    name: 'press-media-library-gallerycategory-gallery',
                    params: { gallerycategory: categorySlug, gallery: slug },
                })
            "
            class="block mb-2 z-1"
        >
            <div class="relative">
                <div class="mb-2 z-1">
                    <div class="thumbnail base-responsive-rounding aspect-h-3 aspect-w-5">
                        <img v-lazy-load :data-src="img" :alt="title" />
                    </div>
                </div>
                <span
                    class="bg-white w-8 h-8 rounded-full absolute bottom-2 right-2 inline-flex items-center justify-center z-2 pointer-events-none"
                >
                    <i class="pi pi-folder"> </i>
                </span>
            </div>

            <div class="auxiliary-text mb-2">{{ photosCount }} {{ $tc('media_library.photo', photosCount) }}</div>

            <h3 v-if="title" class="font-Poppins text-base sm:text-lg font-semibold uppercase mb-2">
                {{ title }}
            </h3>

            <Button
                tabindex="-1"
                :label="$t('media_library.see_gallery_button_label')"
                class="p-button-secondary p-button-text -translate-x-2"
                icon="pi pi-chevron-right"
            />
        </NuxtLink>
    </article>
</template>

<script>
export default {
    name: 'InstitutionGalleryCard',
    props: {
        categorySlug: {
            type: String,
            required: true,
        },
        slug: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: null,
        },
        img: {
            type: String,
            required: true,
        },
        photosCount: {
            type: Number,
            required: true,
        },
    },
};
</script>

<style scoped></style>
